// Not using Intl.ListFormat because for the en-US locale it uses serial comma while our design doesn't (it might also differ across browsers)
const formatList = (list: string[]) => {
  switch (list.length) {
    case 0:
      return "";
    case 1:
      return list[0];
    default:
      return `${list.slice(0, -1).join(", ")} and ${list[list.length - 1]}`;
  }
};

export default formatList;
